// components/OgrenciExportModal.js
import React from 'react';

const OgrenciExportModal = ({
  isOpen,
  onClose,
  selectedColumns,
  setSelectedColumns,
  onExportPDF,
  onExportExcel
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg">
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 px-6 py-4 rounded-t-2xl">
          <h3 className="text-xl font-bold text-white flex items-center">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Rapor Ayarları
          </h3>
        </div>
        
        <div className="p-6">
          <p className="text-gray-700 mb-4">Rapora dahil edilecek sütunları seçin:</p>
          <p className="text-sm text-gray-500 mb-6">Ad Soyad ve Email her zaman dahil edilir.</p>
          
          <div className="space-y-3">
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.durum}
                onChange={(e) => setSelectedColumns({...selectedColumns, durum: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Durum</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.kayitDurumu}
                onChange={(e) => setSelectedColumns({...selectedColumns, kayitDurumu: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Kayıt Durumu</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.veli}
                onChange={(e) => setSelectedColumns({...selectedColumns, veli: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Veli Bilgileri (Ad, Telefon)</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.sinif}
                onChange={(e) => setSelectedColumns({...selectedColumns, sinif: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Eğitim Bilgileri (Sınıf, Okul)</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.kayitTarihi}
                onChange={(e) => setSelectedColumns({...selectedColumns, kayitTarihi: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Kayıt Tarihi</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.sirket}
                onChange={(e) => setSelectedColumns({...selectedColumns, sirket: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Kayıtlı Şirket</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.dersler}
                onChange={(e) => setSelectedColumns({...selectedColumns, dersler: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Dersler</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.ogretmenler}
                onChange={(e) => setSelectedColumns({...selectedColumns, ogretmenler: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Öğretmenler</span>
            </label>
            
            <label className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors">
              <input
                type="checkbox"
                checked={selectedColumns.aciklama}
                onChange={(e) => setSelectedColumns({...selectedColumns, aciklama: e.target.checked})}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 mr-3"
              />
              <span className="text-gray-700">Açıklama</span>
            </label>
          </div>
          
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <button
              className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 text-white px-4 py-2.5 rounded-lg hover:from-red-700 hover:to-pink-700 transition-all flex items-center justify-center shadow-lg"
              onClick={onExportPDF}
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              PDF İndir
            </button>
            <button
              className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white px-4 py-2.5 rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all flex items-center justify-center shadow-lg"
              onClick={onExportExcel}
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Excel İndir
            </button>
          </div>
          
          <button
            className="w-full mt-3 bg-gray-200 text-gray-700 px-4 py-2.5 rounded-lg hover:bg-gray-300 transition-colors"
            onClick={onClose}
          >
            İptal
          </button>
        </div>
      </div>
    </div>
  );
};

export default OgrenciExportModal;